import { FreewheelModel } from 'tag/ts/tag/model/ads/freewheel/FreewheelModel';
import { AbstractAssetPlaybackUtility } from 'tag/ts/tag/player/adapters/avia/utilities/AbstractAssetPlaybackUtility';
import { FWUtilities } from 'tag/ts/tag/utilities/FWUtilities';
export class PIDPlaybackUtility extends AbstractAssetPlaybackUtility {
    constructor(argument) {
        super({
            name: 'PIDPlaybackUtility',
            ...argument
        });
    }
    getMediaUrl() {
        const fwModel = new FreewheelModel({ tag: this.tag });
        const fwUtil = FWUtilities.getInstance();
        const millstoneMetadata = this?.tag?.tagUtilities?.millstoneMetadata(this.params);
        const isIntl = this.isIntl();
        const videoAdsEnabled = this?.videoAdsEnabled();
        let mediaUrl;
        if (millstoneMetadata?.valid) {
            mediaUrl = millstoneMetadata?.millstone?.streamingUrl;
        }
        if (!millstoneMetadata?.valid) {
            mediaUrl = this?.apiMetadata?.streamingUrl;
        }
        if (isIntl && videoAdsEnabled) {
            mediaUrl = fwUtil.createFWUrl(fwModel, mediaUrl);
        }
        this?.logger?.log('getMediaUrl:', '\nmillstoneMetadata:', millstoneMetadata, '\nmillstone.streamingUrl:', millstoneMetadata?.millstone?.streamingUrl, '\napiMetadata.streamingUrl:', this?.apiMetadata?.streamingUrl, '\nisIntl:', isIntl, '\nvideoAdsEnabled:', videoAdsEnabled, '\nreturning url:', mediaUrl);
        return mediaUrl;
    }
}
